import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import './Error.css'; // External styles for maintainability

/**
 * Error Component - Displays an error message with navigation back to home.
 *
 * @param {string} message - Optional custom error message.
 */
const Error = ({ message = 'An unexpected error occurred.' }) => {
  const navigate = useNavigate();

  /**
   * Safely navigate to home with error handling.
   */
  const handleBackToHome = () => {
    try {
      navigate('/');
    } catch (err) {
      console.error('Navigation error:', err);
      // Optional: fallback reload if navigate fails
      window.location.href = '/';
    }
  };

  return (
    <main className="error-container" aria-label="Error Page">
      <section className="error-content">
        <h1 className="error-title">⚠️ Error</h1>
        <p className="error-message">{message}</p>
        <button
          type="button"
          className="error-button"
          aria-label="Go back to homepage"
          onClick={handleBackToHome}
        >
          Back to Home
        </button>
      </section>
    </main>
  );
};

Error.propTypes = {
  message: PropTypes.string, // Allows passing custom error messages
};

export default Error;
